/* eslint-disable */

export enum FilterDisplayType {
	Group = -1,
	Standard = 0,
	NoHeader = 1,
	Slider = 2,
	FromTo = 3,
	SingleValue = 4,
	Category = 5,
	SimpleSlider = 6,
	CategoryNavigation = 7,
	
}
